<template>
  <div class="sso-container">
    <!-- 加载中提示 -->
    <div v-if="loading" class="loading-wrapper">
      <img src="https://img.zhujiaxian.com/2025/05/21f52dbb86f247098f3b3add676a775b.gif" alt="加载中" class="loading-gif">
    </div>
  </div>
</template>

<script>
// 导入登录API
import { GetLoginByPassword } from "@/https/http.js";

export default {
  name: 'PasswordLogin',
  data() {
    return {
      loading: true // 默认开启加载动画，等待单点登录完成
    };
  },
  created() {
    // 检查是否有机关事务单点登录参数
    const mobile = this.getUrlParam('mobile');
    const timestamp = this.getUrlParam('timestamp');
    const sign = this.getUrlParam('sign');

    if (mobile && timestamp && sign) {
      // 存在参数，自动执行单点登录
      this.jgswLogin(mobile, timestamp, sign);
    } else {
      // 缺少参数，关闭加载并提示错误
      this.loading = false;
      this.$toast.fail("缺少单点登录参数！");
    }
  },
  methods: {
    // 获取url中的参数
    getUrlParam(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); 
      const r = window.location.search.substr(1).match(reg); 
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },

    // 机关事务单点登录
    jgswLogin(mobile, timestamp, sign) {
      let data = {
        mobile: mobile,
        timestamp: timestamp,
        sign: sign
      };
      
      GetLoginByPassword(data)
        .then((res) => {
          if (res.data && res.data.access_token) {
            // 存储 token
            localStorage.setItem(
              "token",
              res.data.token_type + res.data.access_token
            );
            // 登录成功后直接进入 User 页面
            this.$router.replace({ path: "/User" });
          } else {
            this.loading = false;
            this.$toast.fail("登录失败：Token获取异常");
          }
        })
        .catch((error) => {
          console.error("机关事务单点登录失败", error);
          this.loading = false;
          this.$toast.fail(error?.data || "单点登录失败");
        });
    }
  }
};
</script>

<style lang="less" scoped>
.sso-container {
  width: 100vw;
  height: 100vh;
  background: #fff;
  position: relative;
}

/* 覆盖全屏的加载动画样式 */
.loading-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff; /* 使用纯白背景覆盖，提供平滑的视觉体验 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  .loading-gif {
    width: 100px; /* 根据实际需求调整图片尺寸 */
    height: 100px;
    object-fit: contain;
  }
}
</style>